import { replicate } from "fp-ts/lib/Array";
import React from "react";

export function replicateSeparator(
  n: number,
  sep: React.ComponentType<any>,
): Array<React.ReactNode> {
  return [
    ...replicate(n - 1, sep).map((x, key) => React.createElement(x, { key })),
    null,
  ];
}

export type StringsMap<T extends string> = Record<
  T,
  NonNullable<React.ReactNode>
>;

/* global navigator */
// this can be useful to workaround Safari syntetic events
// see: http://sitr.us/2011/07/28/how-mobile-safari-emulates-mouse-events.html
export function isTouchEnabled() {
  return (
    typeof window !== "undefined"
    && ("ontouchstart" in window
      || navigator.maxTouchPoints > 0
      // @ts-ignore
      || navigator.msMaxTouchPoints > 0)
  );
}
